import Cookies from 'js-cookie'

const user = {
  state: {
    uid: 0,
    username: '',
    token: '',
    permission: []
  },
  mutations: {
    setUid (state, uid) {
      state.uid = uid
      Cookies.set('uid', uid)
    },
    setUsername (state, username) {
      state.username = username
      Cookies.set('username', username)
    },
    setToken (state, token) {
      state.token = token
      Cookies.set('token', token)
    },
    setPermission (state, permission) {
      console.log(permission)
      state.permission = permission
      Cookies.set('permission', permission)
    },
    logOut (state) {
      state.uid = 0
      state.token = ''
      state.username = ''
      Cookies.remove('uid')
      Cookies.remove('username')
      Cookies.remove('token')
      Cookies.remove('permission')
    }
  },
  actions: {
    setUid (context, uid) {
      context.commit('setUid', uid)
    },
    setUsername (context, username) {
      context.commit('setUsername', username)
    },
    setToken (context, token) {
      context.commit('setToken', token)
    },
    setPermission (context, permission) {
      context.commit('setPermission', permission)
    },
    logOut ({commit}) {
      commit('logOut')
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user.js